export default __webpack_public_path__ + "static/media/Rifle_Magazine.256.625bc77e.png";